<template>
    <div class="property">
        <el-form :ref="refName" :model="formData" :rules="rules" label-width="236px">
            <el-row v-for="(item, index) in source"
                :key="index">
            <el-form-item v-if="item.key.toLowerCase().indexOf('multiroute') == -1 && item.key !='nodeId'
            && item.name.indexOf('本地存储') == -1 && item.name.indexOf('腾讯云') == -1"
                :label="item.name"
                :title="item.name"
                :prop="item.key"
                :rules="item.required ? rules.requiredRule : []"
                >
                <el-select v-if="item.type.toLowerCase() =='ip' || item.type.toLowerCase() =='wanip'"
                    v-model="formData[item.key]"
                    @change="selectIP(item)"
                    @focus="ipFocus(item)"
                    style="margin-bottom:22px;width: 46%;"
                    :disabled="!ableEdit"
                    :prop="item.key"
                    >
                  <div v-if="item.type.toLowerCase() =='ip'">
                    <el-option v-for="(option, id) in sourceVals"
                        :key="id"
                        :label="option.ip"
                        :value="option.ip"></el-option>
                  </div>
                  <div v-else>
                    <el-option v-for="(option, id) in changeWanIPlist(item)"
                               :key="id"
                               :label="option.value"
                               :value="option.value"></el-option>
                  </div>
                </el-select>
                <div v-if="item.brother && item.brother.ports">
                  <div v-for="bro in item.brother.ports">
                    <div v-if="hasServiceHelper && bro.key == 'config_port'"></div>
                    <el-form-item v-else label-width="236px" style="margin-left: -236px;margin-bottom:22px;"
                        :key="bro.key"
                        :label="bro.name"
                        :title="bro.name"
                        :prop="bro.key"
                        :rules="bro.required ? [rules.port, rules.requiredRule] : [rules.port]"
                        >
                        <el-input v-model.number="formData[bro.key]" style="width: 46%;"
                             type="number"
                            @focus="portFocus(bro, formData[item.key], item.type)"
                            :disabled="!ableEdit"
                        ></el-input>
                        <div class="tips" v-if="bro.tips">端口范围：{{bro.tips}}</div>

                    </el-form-item>
                  </div>
                </div>
                <div v-if="item.brother && item.brother.ranges">
                    <div v-for="(bro, idx) in item.brother.ranges" :key="idx">
                        <el-form-item v-for="range in bro.range" :key="range.key" label-width="236px" style="margin-left: -236px;margin-bottom:22px;"
                        :label="range.name"
                        :title="range.name"
                        :prop="range.key"
                        :rules="range.required ? [rules.port, rules.requiredRule] : [rules.port]">
                            <el-input v-model="formData[range.key]" style="width: 46%;" type="number"
                                @focus="rangeFocus(bro.range, range, formData[item.key], item.type)"
                                :disabled="!ableEdit"
                            ></el-input>
                            <div class="tips" v-if="range.tips">端口范围：{{range.tips}}</div>
                        </el-form-item>
                    </div>
                </div>

                <el-input v-if="item.type.toLowerCase() !='array'
                                && item.type.toLowerCase() !='ip'
                                && item.type.toLowerCase() !='wanip'
                                && item.type.toLowerCase() !='boolean'
                                && item.key !='relay_id'
                                && item.key != 'nodeId'"
                    v-model="formData[item.key]"
                    :disabled="!ableEdit"
                    style="width: 46%;margin-bottom:22px;"></el-input>
                <el-form-item
                    :prop="item.key"
                    :rules="rules.relayId"
                    v-if="item.key == 'relay_id'">
                    <el-input v-model="formData[item.key]" type="number" min="1" max="1000"
                        style="width: 46%;margin-bottom:22px;"
                        :disabled="!ableEdit"></el-input>
                    <div class="tips">1~1000</div>
                </el-form-item>
                <!-- <el-form-item
                    :prop="item.key"
                    :rules="rules.nodeId"
                    v-if="item.key == 'nodeId'">
                    <el-input v-model="formData[item.key]" type="number" min="1000000000000000" max="9999999999999999"
                        :disabled="!ableEdit"
                        style="width: 46%;margin-bottom:22px;"></el-input>
                    <div class="tips">
                        以1到9开头的16位数字！并且<span style="color:red;">确保全局唯一</span>
                    </div>
                </el-form-item> -->

                <el-select v-if="item.type.toLowerCase() == 'boolean' && item.key.toLowerCase() != 'warn_switch'"
                    :disabled="!ableEdit"
                    v-model="formData[item.key]">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
                <el-select v-if="item.type.toLowerCase() == 'boolean' && item.key.toLowerCase() == 'warn_switch'"
                    :disabled="!ableEdit"
                    v-model="formData[item.key]">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                </el-select>

                <el-collapse v-if="item.type.toLowerCase() == 'array' && formData[item.key] ">
                    <div v-for="(arr, arrIndex) in formData[item.key]"
                        :key="arrIndex">
                        <el-col :span="22">
                            <el-collapse-item
                                :name="'n'+item.key + arrIndex"
                                >
                                <template slot="title">
                                    <span class="collapse-title">
                                        实例{{arrIndex+1}}
                                    </span>
                                </template>
                                <div>
                                    <property-item :ref="item.key + arrIndex"
                                        :refName="item.key + arrIndex"
                                        :source="item.family.members"
                                        :sourceVals="sourceVals"
                                        :itemForm="arr"
                                        :ableEdit="ableEdit"
                                        :occupyResourceData="occupyResourceData"/>
                                </div>
                            </el-collapse-item>
                        </el-col>
                        <el-col :span="2" style="height:48px;line-height:48px;">
                            <i class="el-icon-circle-plus titleIcon"
                                @click="addInstance(formData, item.key, arrIndex)"></i>

                            <i class="el-icon-delete titleIcon"
                                v-if="formData[item.key].length > 1"
                                @click="delInstance(formData, item.key, arrIndex, item.family.members, arr)"></i>
                        </el-col>
                    </div>
                </el-collapse>


            </el-form-item>
            <el-row v-else>
                <el-form-item v-if="item.type.toLowerCase() == 'boolean'"
                    :label="item.name"
                    :title="item.name"
                    :prop="item.key"
                    :rules="item.required ? rules.requiredRule : []"
                    >
                    <el-select
                        :disabled="!ableEdit"
                        v-model="formData[item.key]"
                        @change="showRelated = (formData[item.key] ? true : false)">
                        <el-option :value="true" label="是"></el-option>
                        <el-option :value="false" label="否"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="formData.isMultiRoute && item.type.toLowerCase() != 'boolean'"
                    :label="item.name"
                    :title="item.name"
                    :prop="item.key"
                    :rules="item.required ? rules.requiredRule : []"
                    >
                        <el-select v-if="item.type.toLowerCase() =='ip' || item.type.toLowerCase() =='wanip'"
                            v-model="formData[item.key]"
                            @change="selectIP(item)"
                            @focus="ipFocus(item)"
                            style="margin-bottom:22px;width: 46%;"
                            :disabled="!ableEdit"
                            >
                          <div v-if="item.type.toLowerCase() =='ip'">
                            <el-option v-for="(option, id) in sourceVals"
                                :key="id"
                                :label="option.ip"
                                :value="option.ip"></el-option>
                          </div>
                          <div v-else>
                            <el-option v-for="(option, id) in changeWanIPlist(item)"
                                       :key="id"
                                       :label="option.value"
                                       :value="option.value"></el-option>
                          </div>
                        </el-select>

                        <div v-if="item.brother && item.brother.ports">
                            <el-form-item label-width="236px" style="margin-left: -236px;margin-bottom:22px;"
                                v-for="bro in item.brother.ports"
                                :key="bro.key"
                                :label="bro.name"
                                :title="bro.name"
                                :prop="bro.key"
                                :rules="bro.required ? [rules.port, rules.requiredRule] : [rules.port]"
                                >
                                <el-input v-model="formData[bro.key]" style="width: 46%;" type="number"
                                    @focus="portFocus(bro, formData[item.key], item.type)"
                                    :disabled="!ableEdit"
                                ></el-input>
                                <div class="tips" v-if="bro.tips">端口范围：{{bro.tips}}</div>

                            </el-form-item>
                        </div>
                        <div v-if="item.brother && item.brother.ranges">
                            <div v-for="(bro, idx) in item.brother.ranges" :key="idx">
                                <el-form-item v-for="range in bro.range" :key="range.key" label-width="236px" style="margin-left: -236px;margin-bottom:22px;"
                                :label="range.name"
                                :title="range.name"
                                :prop="range.key"
                                :rules="range.required ? [rules.port, rules.requiredRule] : [rules.port]">
                                    <el-input v-model="formData[range.key]" style="width: 46%;"
                                        @focus="rangeFocus(bro.range, range, formData[item.key], item.type)"
                                        :disabled="!ableEdit"
                                    ></el-input>
                                    <div class="tips" v-if="range.tips">端口范围：{{range.tips}}</div>
                                </el-form-item>
                            </div>
                        </div>
                </el-form-item>

<!--              <el-form-item v-if="item.key.toLowerCase() == 'default_enable' || item.key == 'tencentOSS_enable'"-->
<!--                            :label="item.name"-->
<!--                            :title="item.name"-->
<!--                            :prop="item.key"-->
<!--                            :rules="item.required ? rules.requiredRule : []"-->
<!--              >-->
<!--                  <el-select-->
<!--                    :disabled="!ableEdit"-->
<!--                    v-model="formData[item.key]"-->
<!--                    @change="showRelated = (formData[item.key] ? true : false)">-->
<!--                    <el-option :value="true" label="是"></el-option>-->
<!--                    <el-option :value="false" label="否"></el-option>-->
<!--                  </el-select>-->

<!--              </el-form-item>-->
              <el-form-item v-if="(formData.default_enable && item.key.toLowerCase() != 'default_enable' && item.name.indexOf('本地存储') != -1)
              || formData.tencentOSS_enable && item.key != 'tencentOSS_enable' && item.name.indexOf('腾讯云') != -1"
                            :label="item.name"
                            :title="item.name"
                            :prop="item.key"
                            :rules="item.required ? rules.requiredRule : []"
              >
                <el-input
                          v-model="formData[item.key]"
                          :disabled="!ableEdit"
                          style="width: 46%;margin-bottom:22px;"></el-input>
              </el-form-item>

            </el-row>
                <el-form-item
                    :label="item.name"
                    :prop="item.key"
                    :rules="rules.nodeId"
                    v-if="item.key == 'nodeId'">
                    <el-input v-model="formData[item.key]" type="number" min="1000000000000000" max="9999999999999999"
                        :disabled="!ableEdit"
                        style="width: 46%;margin-bottom:22px;"></el-input>
                    <div class="tips">
                        以1到9开头的16位数字！并且<span style="color:red;">确保全局唯一</span>
                    </div>
                </el-form-item>


            </el-row>
        </el-form>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
    name: 'PropertyItem',
    props: {
        // 资源定义
        source: {
            type: Array,
            default:()=>{
                return []
            },
            required: true
        },
        // 资源列表
        sourceVals: {
            type: Array,
            required: true
        },
      occupyResourceData: {
        type: Object
      },
        itemForm: {
            type: Object,
            // required: true
        },
        refName: {
            type: String
        },
        // 是否可分配资源
        ableEdit: {
            type: Boolean,
            default: true
        },
        // 是否hasServiceHelper
        hasServiceHelper: {
          type: Boolean,
          default: false
        },
        // 是否是查看资源
        resourceDetail: {
            type: Boolean,
            default: false
        }
    },
    data(){
        /*
        * 功能：校验端口是否在有效范围内
        *
        * 方法2-------
        * 1.每个ip都有一个数组，长度为65536，且每个元素数值为-1
        * 2.该端口对应的有效范围标记为1
        * 3.当前端口focus的时候，取端口值，并存到oldPort里，当端口blur的时候，
        *   3.1 比较当前端口值和oldPort
        *           如果相同，返回，不做校验；
        *           如果不同,执行3.2
        *   3.2 检查当前值对应的数组位置：
        *           如果是-1，无效范围，检验不通过；
        *           否则，执行3.5
        *   3.5 检查当前端口的协议protocol值：
        *           null(表示当前端口是tcp+udp)，当前位置对应的值如果是2/3/4, 端口被占用，不通过，否则执行3.6；
        *           1(tcp)，当前位置对应的值如果是2/3,端口被占用，不通过，否则执行3.6；
        *           2(udp)，当前位置对应的值如果是2/4,端口被占用，不通过，否则执行3.6；
        *   3.6 如果当前端口类型是port，该位置标记为占用(protocol为null,标记2，'1', 标记3，'2'标记为4); 否则执行3.3
        *   3.3 取开始和结束端口（默认为-1），
        *           如果任意一个为-1，校验通过；
        *           如果start >= end, 提示开始端口要小于结束端口，校验不通过；
        *           否则执行3.4
        *   3.4 如果oldPort < start, oldPort~start中值为2的位置重置为1
        *       如果oldPort > end, end~oldPort中值为2的位置重置为1
        *       否则，start~end,
        *           如果区间内有2，提示已占用，检验不通过；
        *           如果区间内有-1，提示超出范围，检验不通过；
        *           如果区间内所有值都为1，置为2，表示要占用；
        */
        let validatePort2 = (rule, value, callback) => {
            const val = Number(value)
            let _this = this
            if(val < 0 || val > 65535){
                callback(new Error('不在有效范围内'))
                _this.oldPort = ''
                return
            }

            let flag = 0

            let oldPort = _this.oldPort
            //获取当前端口和当前IP的对象-start
            const key = rule.field

            _this.setCurrentPort(key, _this.source, _this.formData)
            //获取当前端口和当前IP的对象-end
            let item = _this.currentPort
            let protocol = item.protocol //当前端口的协议
            let portType = _this.currentIPType.toLowerCase() == 'ip' ? 'inner' : 'outer'
            let anotherType = portType == 'inner' ? 'outer' : 'inner'

            let arrs = _this[portType+'port'].filter(p => p.ip == _this.currentIP)
            let anotherArrs = _this[anotherType+'port'].filter(p => p.ip == _this.currentMapIP)
            let array = _this.initArr(arrs, item)

            let anotherItem = _this.findAnotherItme(item);
            let anotherArray = [];
            if(anotherItem){
              anotherArray = _this.initArr(anotherArrs, anotherItem);
            }


            let start = -1
            let end = -1
            let broRange
            let anotherPort
            let rkey
          // 处理是否是占用资源的端口
          if(_this.occupyResourceData && _this.occupyResourceData.networkList){
            for(let i = 0;i < _this.occupyResourceData.networkList.length;i++){
              let obj = _this.occupyResourceData.networkList[i];
              if(obj.ports && obj.ports.length > 0){
                let objPort;
                for(let j = 0;j < obj.ports.length;j++){
                  objPort = obj.ports[j];
                  if( value == objPort.value){
                    if(item.mapping){
                      _this.autoMapSelectInstance(item, portType)
                    }

                    callback();
                    return
                  }
                }
              }

              if(obj.portRange && obj.portRange.length > 0){
                let objRange;
                for(let n = 0;n < obj.portRange.length;n++){
                  objRange = obj.portRange[n];
                  for(let k = objRange.start; k <= objRange.end;k++ ){
                    if( value == k){
                      if(item.mapping){
                        _this.autoMapSelectInstance(item, portType)
                      }
                      callback();
                      return
                    }
                  }
                }
              }
            }
          }

            if(Object.keys(item).length == 0){
                if(item.required){
                    callback(new Error('必填项'))
                }else{
                    callback()
                }
                _this.oldPort = ''
                return
            }

            if(item.type.toLowerCase() != "port"){
                broRange = _this.currentRange.filter(r => r.key != item.key)[0]
                anotherPort = _this.formData[broRange.key] != '' ? Number(_this.formData[broRange.key]) : -1
                if(item.type.toLowerCase() == "startport"){
                    start = val
                    end = anotherPort
                }else{
                    end = val
                    start = anotherPort
                }
                rkey = _this.currentRange[0].key + _this.currentRange[1].key

                if(_this.rangeVerified.indexOf(rkey + start + end) != -1){
                    callback()
                    _this.oldPort = ''
                    return
                }
            }

            // 端口已被占用的集合
            const vindex = _this.validatedFailed.findIndex(v => v.key == key && v.port == oldPort)

            // 端口号改变且原端口不为空，处理原端口
            if(oldPort !== '' && oldPort !== -1 && oldPort != value){
                // 1.删除之前端口号 已验证过的映射关系
                _this.delVerifiedMap(oldPort, protocol)

                if(item.type.toLowerCase() == "port"){
                    // 2.重置原端口
                    _this.resetOldPort(oldPort, vindex, array, portType, item, anotherArray, anotherType)
                }else{
                    // 3.重置原端口范围
                    let resetStart = -1
                    let resetEnd = -1
                    if(item.type.toLowerCase() == 'startport'){
                        resetStart = Number(oldPort)
                        resetEnd = end
                    }else{
                        resetStart = start
                        resetEnd = Number(oldPort)
                    }

                    if(resetStart != -1 && resetEnd != -1){
                        // 删除已验证通过的范围
                        _this.updateRangeVerified({
                            type: 'del',
                            data: rkey + resetStart + resetEnd
                        })
                        // 重置有效范围
                        _this.resetValidRange(resetStart, resetEnd, array, protocol, portType)
                    }

                }
            }
            if(oldPort == value && array[val] != -1 && vindex == -1){
                if(item.type.toLowerCase() == "port"){
                    flag = 1
                }else{
                    if(start == -1 || end == -1){
                        flag = 1
                    }else{
                        let rExist = false
                        for(let r=start; r<=end; r++){
                            const rindex = _this.validatedFailed.findIndex(v => v.key == rkey && v.port == r)
                            if(rindex!=-1){
                                rExist = true
                            }
                        }
                        if(!rExist){
                            flag = 1
                        }else{
                            callback('区间内有端口已被占用')
                        }
                    }
                }
            }else{
                // array = _this.initArr(arrs, item)
                // anotherArray = _this.initArr(anotherArrs, item)
                if(value){
                    if(array[val] == -1){
                        // _this.resetOldPort(oldPort, vindex, array, portType, item, anotherArray, anotherType)
                        callback(new Error('不在有效范围内'))
                    }else if(_this.portOccupated(protocol, array[val])){
                        console.log(array[val]+','+portType)
                        _this.validatedFailed.push({
                            key: key,
                            port: value
                        })
                        // 如果端口号改变，检查oldport是否为有效端口，如果是，需要将其重置
                        // _this.resetOldPort(oldPort, vindex, array, portType, item, anotherArray, anotherType)

                        callback( new Error(`端口已被${protocol == 1 ? 'TCP' : protocol == 2 ? 'UDP' : ''}占用`))
                    }else{
                        if(item.type.toLowerCase() == "port"){
                            // array[val] = protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                            if(array[val] == 1){
                                array[val] = protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                            }else{
                                array[val] = 2
                            }

                            // if(oldPort !== '' && array[Number(oldPort)] != -1){
                            //     if( vindex == -1){
                            //         // array[Number(oldPort)] = 1
                            //         if(array[Number(oldPort)] != 2){
                            //             array[Number(oldPort)] = 1
                            //         }else{
                            //             array[Number(oldPort)] = protocol == 1 ? 4 : (protocol == 2 ? 3: 1)
                            //         }
                            //     }else{
                            //         _this.validatedFailed.splice(vindex, 1)
                            //     }
                            // }
                            flag = 1

                            // 端口自动映射-start
                            if(item.mapping){
                                const autoResult =  _this.autoMap(item, portType, anotherType, anotherArray)
                                if(autoResult == -1){
                                    callback(new Error('映射端口被占用，请重新分配'))
                                }else{
                                    flag = 1
                                }
                            }
                            // 端口自动映射-end

                        }else{
                            if(start == -1 || end == -1){
                                flag = 1
                            }else if(start >= end){
                                callback(new Error('开始端口要小于结束端口'))
                            }else{
                                const nPort = Number(_this.oldPort)

                                // if(oldPort != '' && (nPort < start)){
                                //     // 重置有效范围并且删除原来区间内已占用的端口
                                //     _this.resetValidRange(nPort, end, array, protocol)
                                // }else if(oldPort != '' && (nPort > end)){
                                //     // 重置有效范围并且删除原来区间内已占用的端口
                                //     _this.resetValidRange(start, nPort, array, protocol)
                                // }else if(oldPort != '' ){
                                //     if(item.type.toLowerCase() == "startport"){
                                //         _this.resetValidRange(nPort, end, array, protocol)
                                //     }else{
                                //         _this.resetValidRange(start, nPort, array, protocol)
                                //     }
                                // }
                                // else{
                                    // 1.检查端口是否有效 2.标记占用端口
                                    let exist_2 = false, exist_invalid= false
                                    for(let z = start; z<= end; z++){
                                        if(array[z] == -1){
                                            exist_invalid = true
                                            callback(new Error('无效范围'))
                                            break
                                        }else if(_this.portOccupated(protocol, array[z])){

                                            _this.validatedFailed.push({
                                                key: _this.currentRange[0].key + _this.currentRange[1].key,
                                                port: z
                                            })
                                            exist_2 = true
                                            callback(new Error('区间内有端口已被占用'))
                                            break
                                        }
                                    }
                                    if(!exist_2 && !exist_invalid){
                                        for(let q = start; q <= end; q++){
                                            // array[q] = protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                                            if(array[q] == 1){
                                                array[q] = protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                                            }else{
                                                array[q] = 2
                                            }
                                        }
                                        flag = 1

                                        _this.updateRangeVerified({
                                            type: 'add',
                                            data: rkey + start + end
                                        })
                                    }
                                // }
                            }
                        }

                        _this.updateEle({
                            ip: _this.currentIP,
                            portArray: array,
                            type: portType
                        })

                    }
                }else{
                    flag = 1
                }
            }



            if(flag == 1){
                callback()
            }
            _this.oldPort = ''

        }

        let relayIdValidate = (rule, value, callback)=>{
            if(value < 1 || value > 1000){
                callback(new Error('不在有效范围内'))
            }else{
                callback()
            }
        }
        let nodeIdValidate = (rule, value, callback)=>{
            if(Number(value) < 1000000000000000 || Number(value) > 9999999999999999){
                callback(new Error('不在有效范围内'))
            }else{
                callback()
            }
        }

        let selectValidator = (rule, value, callback)=>{
            console.log(rule)
            callback()
        }

        return {
            formData: {},
            rules: {
                port: {validator: validatePort2, trigger: 'blur'},
                requiredRule: {required:true, message: '必填项'},
                relayId: [{validator: relayIdValidate}],
                nodeId: [{validator: nodeIdValidate},{required:true, message: '必填项'}],
                selectRule: [{validator: selectValidator}]
            },
            oldPort: -1, //当前端口原来的值
            currentIP: '', //端口对应的ip
            currentPort: {}, //当前端口对象
            currentRange: [], //当前端口范围
            oldIP: '', //点击选择ip之前，ip值
            currentIPItem: {}, //ip对应的资源定义对象
            currentIPType: '',
            validatedFailed: [], //端口是否已验证过,并且验证结果为端口占用。该情况下，更改端口号，不清空原端口
            currentMapIP: '', //映射ip
            currentItemFinded: false, //删除实例时，是否查到当前的端口对象
            showRelated: false, //多路配置单独处理
            showRelated1: false,

        }
    },
    computed: {
        ...mapState(['innerport', 'outerport', 'allref', 'portmapVerified', 'rangeVerified']),
      changeWanIPlist( item ){
          let _this = this
        return (item) => {
          let array = []
          for(let i=0; i<_this.sourceVals.length; i++){
            if(_this.formData[item.mapping] == _this.sourceVals[i].ip){
              if(_this.sourceVals[i].ipMappingList && _this.sourceVals[i].ipMappingList.length >0 ){
                _this.sourceVals[i].ipMappingList.forEach( e => {
                  array.push({
                    value: e.ip
                  })
                })
              }else {
                array.push({
                  value: _this.sourceVals[i].ip
                })
              }
              break;
            }
          }


          return array;
        }
      }
    },
    watch:{
        source:{
            handler (newVal, oldVal) {
                this.initForm(newVal, this.formData)
                // this.renderRules(newVal)
                // console.log(newVal)
            },
            deep: true //是否深度监听
        },
        sourceVals:{
            handler (newVal, oldVal) {
                if(newVal != oldVal){
                    this.displayResource()
                }
            },
            deep: true //是否深度监听
        },
        formData: {
            handler (newVal, oldVal) {
                this.$emit('update:itemForm', newVal)
                // console.log(this.source)
                // this.renderRules(this.source)
                let refindex = this.allref.indexOf(this.refName)
                if(refindex == -1){
                    this.updateRef(this.refName)
                }
            },
            deep: true //是否深度监听
        },
        itemForm: {
            handler (newVal, oldVal) {
                this.formData = newVal

                if(newVal != oldVal){
                    this.displayResource()
                }

                // const _this = this
                // for(let key in newVal){
                //     if(key.toLowerCase().endsWith('ip') && newVal[key]){
                //         const item = _this.source.filter(s => s.key == key)
                //         if(item.length > 0){
                //             _this.selectIP(item[0], null, true)
                //         }
                //     }
                // }
            },
            deep: true //是否深度监听
        },
        occupyResourceData:{
        handler (newVal, oldVal) {
          //this.clearPort();
          this.initPort();
          console.log(newVal)
        },
        deep: true //是否深度监听
      },
    },
    mounted(){
        this.formData = this.itemForm
    },
    methods: {
        ...mapMutations(["updateEle", "updateRef", "updatePortmapVerified", "delEle", "updateRangeVerified"]),
        // 重置有效范围并且删除区间内的占用端口
        resetValidRange(start, end, array, protocol, portType){
            let _this = this
            let rkey = _this.currentRange[0].key+_this.currentRange[1].key
            for(let i = start; i<=end; i++){
                const rindex = _this.validatedFailed.findIndex(v => v.key == rkey && v.port == array[i])
                if(rindex != -1){
                    _this.validatedFailed.splice(rindex, 1)
                }

                if(array[i] == 2){
                    array[i] = protocol == 1 ? 4 : (protocol == 2 ? 3: 1)
                }else if(array[i] != -1){
                    array[i] = 1
                }
            }
            _this.updateEle({
                ip: _this.currentIP,
                portArray: array,
                type: portType
            })
        },
        // 如果端口号改变，检查oldport是否为有效端口，如果是，需要将其重置
        resetOldPort(oldPort, vindex, array, portType, item, anotherArray, anotherType){
            let _this = this
            const protocol = item.protocol
                        if(oldPort !== ''){
                            if( vindex == -1){
                                if(array[Number(oldPort)] != -1){
                                    // array[Number(oldPort)] = 1
                                    if(array[Number(oldPort)] != 2){
                                        array[Number(oldPort)] = 1
                                    }else{
                                        array[Number(oldPort)] = protocol == 1 ? 4 : (protocol == 2 ? 3: 1)
                                    }
                                    _this.updateEle({
                                        ip: _this.currentIP,
                                        portArray: array,
                                        type: portType
                                    })
                                }
                            }else{
                                _this.validatedFailed.splice(vindex, 1)
                            }
                        }
                        // 如果映射端口存在且不为空，重置映射的端口为有效
                        if(item.mapping && _this.formData[item.mapping] != ''){
                            // 2020-04-03 14:53 注释(原因：170行已执行过该操作)
                            // _this.delVerifiedMap(_this.formData[item.mapping], protocol)
                            anotherArray[Number(_this.formData[item.mapping])] = 1
                            _this.updateEle({
                                ip: _this.currentMapIP,
                                portArray: anotherArray,
                                type: anotherType
                            })
                            _this.formData[item.mapping] = ''
                        }
        },
        // 端口已映射的集合
        delVerifiedMap(port, protocol){
            const _this = this
            const pvIndex = _this.portmapVerified.findIndex(pv => {
                return (pv.ip.indexOf(_this.currentIP)!=-1 && pv.port.indexOf(Number(port)!=-1 && pv.protocol == protocol))
            })
            if(pvIndex != -1){
                _this.updatePortmapVerified({
                    type: 'del',
                    index: pvIndex
                })
            }
        },
      findAnotherItme(item){
        let anotherItem = null;
        for(let another of this.source){
          if(another.type.toLowerCase() == "ip" || another.type.toLowerCase() == "wanip"){
            if(another.brother && another.brother.ports){
              for(let p of another.brother.ports){
                if(p.key == item.mapping){
                  anotherItem = p
                  break
                }
              }
            }
          }
        }
        return anotherItem
      },
      autoMapSelectIp(selectObj){
        //当选择外网时查看内网port是否填写，如果内网Port填写，则需要把外网port映射
        let _this = this;
        let waiip = this.formData[selectObj.key]
        let item = null;
        let anotherArrs = _this['outerport'].filter(p => p.ip == waiip)
        let anotherArray = []
        if(selectObj && selectObj.brother && selectObj.brother.ports){
          for(let bro of selectObj.brother.ports) {
            anotherArray = _this.initArr(anotherArrs, bro)
            break;
          }
        }
        if(_this.formData[selectObj.mapping]){
          for(let i=0; i<_this.source.length; i++){
            if(selectObj.mapping == _this.source[i].key){
              item = _this.source[i];
              break;
            }
          }
        }
        if(item == null){
          return;
        }

        let innerip = this.formData[item.key]

        let mapPortVal //映射端口值
        if(item && item.brother && item.brother.ports){
          for(let bro of item.brother.ports){
            if(_this.formData[bro.key] && bro.mapping) {
              if(innerip == waiip){
                _this.formData[bro.mapping] = Number(_this.formData[bro.key])
              }else {

                let portMap = bro.limits.portMap ? bro.limits.portMap : []
                let portFilter = portMap.filter(p => p['innerPort'] == _this.formData[bro.key])
                if(portFilter.length == 0){
                  mapPortVal = _this.formData[bro.key]
                }else {
                  mapPortVal = portFilter[0].outerPort
                }
                const mapVal = Number(mapPortVal)
                _this.formData[bro.mapping] = mapVal

                let anotherItem
                for(let another of this.source){
                  let flag = 0
                  if(another.type.toLowerCase() == "ip" || another.type.toLowerCase() == "wanip"){
                    if(another.brother && another.brother.ports){
                      for(let p of another.brother.ports){
                        if(p.key == bro.mapping){
                          flag = 1
                          anotherItem = p
                          break
                        }
                      }
                    }
                  }
                  if(flag == 1){
                    break
                  }
                }
                let protocol = anotherItem.protocol

                if(anotherArray[mapVal] == 1){
                  anotherArray[mapVal] =  protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                }else{
                  anotherArray[mapVal] = 2
                }
                _this.updateEle({
                  ip: waiip,
                  portArray: anotherArray,
                  type: 'outer'
                })

                _this.updatePortmapVerified({
                  data: {
                    ip: [innerip, waiip], //相互映射的ip
                    protocol: protocol,
                    port: [_this.formData[bro.key], mapVal], //相互映射的端口号
                  },
                  type: 'add'
                })
              }
            }
            }
        }
      },
      autoMap(item, portType, anotherType, anotherArray){
            let _this = this
            let result = null
            const val = Number(_this.formData[item.key])
            const oldPort = _this.formData[item.mapping]

            let portMap = item.limits.portMap ? item.limits.portMap : []
            if(_this.currentMapIP == _this.currentIP){
              _this.formData[item.mapping] = val
              return 1
            }else {
              if(portMap.length == 0){
                _this.formData[item.mapping] = val
                return 1
              }
            }

                let portFilter = portMap.filter(p => p[portType + 'Port'] == val)
                //start-2021.03.02 新加
                // portMap只返回端口映射不一致的
                // portFilter没有映射端口直接返回
                if(portFilter.length == 0){
                  // portFilter = [{
                  //   innerPort: val,
                  //   outerPort: val
                  // }]
                  return 1
                }
                //end-2021.03.02

                let mapPortVal //映射端口值

                // if(portFilter.length == 0){
                //     console.log('当前端口没有找到映射端口')
                //     _this.formData[item.mapping] = ''
                //     if(oldPort !== ''){
                //         anotherArray[Number(oldPort)] = 1
                //         _this.updateEle({
                //             ip: _this.currentMapIP,
                //             portArray: anotherArray,
                //             type: anotherType
                //         })
                //     }
                // }else{

                    if(portType == 'inner'){
                        mapPortVal = portFilter[0].outerPort
                    }else{
                        mapPortVal = portFilter[0].innerPort
                    }
                    const mapVal = Number(mapPortVal)


                    // 找到mapping对应的端口对象，根据其protocol表示端口占用值
                    let anotherItem
                    for(let another of this.source){
                        let flag = 0
                        if(another.type.toLowerCase() == "ip" || another.type.toLowerCase() == "wanip"){
                            if(another.brother && another.brother.ports){
                                for(let p of another.brother.ports){
                                    if(p.key == item.mapping){
                                        flag = 1
                                        anotherItem = p
                                        break
                                    }
                                }
                            }
                        }
                        if(flag == 1){
                            break
                        }
                    }

                    if(anotherItem){
                        const protocol = anotherItem.protocol
                        // 先查看该映射关系是否已经验证过(已验证过的数组中存在)，
                        //      如果已验证，则不需再次验证; 如果没验证过，则进行验证
                        const hasVerified = _this.portmapVerified.some(pitem => {
                            return (pitem.ip.indexOf(_this.currentIP) != -1 && item.protocol == pitem.protocol && pitem.port.indexOf(val)!=-1)
                        })
                        if(hasVerified){
                            _this.formData[item.mapping] = mapPortVal
                            return 1
                        }

                        if(_this.portOccupated(protocol, anotherArray[mapVal])){

                            result = -1
                            // 重置原来的映射端口
                            if(anotherArray[Number(oldPort)] == 2){
                                anotherArray[Number(oldPort)] = protocol == 1 ? 4 : (protocol == 2 ? 3 : 1)
                            }else{
                                anotherArray[Number(oldPort)] = 1
                            }
                            if(oldPort !== ''){
                                _this.formData[item.mapping] = ''
                                _this.updateEle({
                                    ip: _this.currentMapIP,
                                    portArray: anotherArray,
                                    type: anotherType
                                })
                            }
                        }else{
                            // anotherArray[mapVal] =  protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                            if(anotherArray[mapVal] == 1){
                                anotherArray[mapVal] =  protocol == 1 ? 3 : (protocol == 2 ? 4: 2)
                            }else{
                                anotherArray[mapVal] = 2
                            }
                            oldPort === '' ? true : anotherArray[Number(oldPort)] = 1
                            _this.updateEle({
                                ip: _this.currentMapIP,
                                portArray: anotherArray,
                                type: anotherType
                            })

                            _this.formData[item.mapping] = mapPortVal

                            _this.updatePortmapVerified({
                                data: {
                                    ip: [_this.currentIP, _this.currentMapIP], //相互映射的ip
                                    protocol: protocol,
                                    port: [val, mapVal], //相互映射的端口号
                                },
                                type: 'add'
                            })
                        }

                    }


                // }
            return result
        },
      autoMapSelectInstance(item, portType){
          let _this = this
          const val = Number(_this.formData[item.key])

          let portMap = item.limits.portMap ? item.limits.portMap : []

          let portFilter = portMap.filter(p => p[portType + 'Port'] == val)

          //start-2021.03.02 新加
          // portMap只返回端口映射不一致的
          if(portFilter.length == 0){
            portFilter = [{
              innerPort: val,
              outerPort: val
            }]
          }
          let mapPortVal //映射端口值
          if(portType == 'inner'){
            mapPortVal = portFilter[0].outerPort
          }else{
            mapPortVal = portFilter[0].innerPort
          }
          //const mapVal = Number(mapPortVal)

          if(item.mapping){
            _this.formData[item.mapping] = mapPortVal
          }
        },
        initArr(arrs, item){
                let array = []
                // const _this = this
                if(arrs.length > 0){
                    array = arrs[0].portArray
                }else{
                    array = new Array(65535).fill(-1)
                    // if(!item.limits){
                    //     const innerObj = this.sourceVals[this.currentIPType]
                    //     const ip = this.currentIP
                    //     let sourceDetail = innerObj.filter(obj => obj.value == ip)[0]
                    //     item.limits = {
                    //         ports: sourceDetail.ports,
                    //         portRange: sourceDetail.portRange,
                    //         portAssets: sourceDetail.portAssets
                    //     }
                    // }
                    const ports = item.limits&&item.limits.ports ? item.limits.ports  : []
                    const range = item.limits&&item.limits.portRange ? item.limits.portRange : []
                    const portAssets = item.limits&&item.limits.portAssets ? item.limits.portAssets : []

                    for(let i of ports){
                        array[Number(i)] = 1
                    }

                    for(let r of range){
                        const start = Number(r.start)
                        const end = Number(r.end)
                        for(let j = start; j<=end; j++){
                            array[j] = 1
                        }
                    }
                    // 如果有端口占用
                    for(let pa of portAssets){
                        array[Number(pa.port)] = pa.protocol == 1 ? 3 : (pa.protocol == 2 ? 4 : 2)
                    }
                }
            return array
        },
        setCurrentPort(key, source, formData){
            let _this = this
            _this.currentItemFinded = false
            for(let item of source){
                let flag = 0
                if(item.type.toLowerCase() == "ip" || item.type.toLowerCase() == "wanip"){
                    if(item.brother && item.brother.ports){
                        for(let p of item.brother.ports){
                            if(p.key == key){
                                _this.currentItemFinded = true
                                flag = 1
                                _this.currentPort = p
                                _this.currentIP = formData[item.key]
                                _this.currentIPType = item.type
                                _this.currentIPItem = item
                                _this.currentMapIP = item.mapping ? formData[item.mapping] : ''
                                break
                            }
                        }
                    }
                    if(flag == 0 && item.brother && item.brother.ranges){
                        for(let r of item.brother.ranges){
                            for(let range of r.range){
                                if(range.key == key){
                                    _this.currentItemFinded = true
                                    flag = 1
                                    _this.currentPort = range
                                    _this.currentIP = formData[item.key]
                                    _this.currentIPType = item.type
                                    _this.currentIPItem = item
                                    _this.currentMapIP = item.mapping ? formData[item.mapping] : ''
                                    _this.currentRange = r.range
                                    break
                                }
                            }
                            if(flag == 1){
                                break
                            }
                        }
                    }
                }
                if(flag == 1){
                    break
                }
            }
        },
        // 根据协议校验端口是否已被占用(2,3,4)
        portOccupated(protocol, val){
            let occu = false
            if(protocol != 1 && protocol !=2){
                if(val == 2 || val == 3 || val == 4){
                    occu = true
                }
            }else if(protocol == 1){
                if(val == 2 || val == 3){
                    occu = true
                }
            }else{
                if(val == 2 || val == 4){
                    occu = true
                }
            }

            return occu
        },
        portFocus(port, ip, ipType){
            this.oldPort = this.formData[port.key]
            this.currentIP = ip
            this.currentPort = port
            this.currentIPType = ipType
        },
        // ranges包含端口范围，range:开始端口/结束端口
        rangeFocus(ranges, range, ip, ipType){
            this.oldPort = this.formData[range.key]
            this.currentRange = ranges
            this.currentPort = range
            this.currentIP = ip
            this.currentIPType = ipType
        },
        // 如果oldIP不为空，则清空oldIP对应的占用端口
        ipFocus(item){
            this.oldIP = this.formData[item.key]
            this.currentIPItem = item
        },
        initForm(source, formData){
            let _this = this
            for(let s of source){
                if(s.type == 'array'){
                    let arr = [{}]
                    if(s.family.members && s.family.members.length > 0){
                        _this.initForm(s.family.members, arr[0])
                    }
                    _this.$set(formData, s.key, arr)
                }else{
                    _this.$set(formData, s.key, '')
                    if(s.brother){
                        if(s.brother.ports){
                            s.brother.ports.forEach(port => {
                                 _this.$set(formData, port.key, '')
                            })
                        }
                        if(s.brother.ranges){
                            s.brother.ranges.forEach(range => {
                                 range.range.forEach(r => {
                                     _this.$set(formData, r.key, '')
                                 })
                            })
                        }
                    }
                }
            }
        },
        clearPort(){
          let _this = this
          for(let s of _this.source){
            if(s.type == 'array'){
              let arr = [{}]
              if(s.family.members && s.family.members.length > 0){
                _this.initForm(s.family.members, arr[0])
              }
              _this.$set(_this.formData, s.key, arr)
            }else{
              if(s.brother){
                if(s.brother.ports){
                  s.brother.ports.forEach(port => {
                    _this.$set(_this.formData, port.key, '')
                  })
                }
                if(s.brother.ranges){
                  s.brother.ranges.forEach(range => {
                    range.range.forEach(r => {
                      _this.$set(_this.formData, r.key, '')
                    })
                  })
                }
              }
            }
          }
        },
        initPort(){
          let _this = this;
          if(_this.occupyResourceData && _this.occupyResourceData.content){

            let objCoent = JSON.parse(_this.occupyResourceData.content)
            console.log(objCoent)

            Object.keys(objCoent).forEach(s =>{
              if(_this.formData.hasOwnProperty(s)){
                 _this.$set(_this.formData, s, objCoent[s])
                }
            })
            _this.displayResource();
          }
        },
        // 组装对象,属性
        renderObject(obj){
            const _this = this
            let item = {}
            if(Object.prototype.toString.call(obj) != '[object Object]'){
                return null
            }
            for(let itemKey in obj){
                if(Object.prototype.toString.call(obj[itemKey]) == '[object Array]'){
                    item[itemKey] = []
                    for(let objItem of obj[itemKey]){
                        item[itemKey].push(_this.renderObject(objItem))
                    }
                }else if(Object.prototype.toString.call(obj[itemKey]) == "[object Object]"){
                    item[itemKey] = _this.renderObject(obj[itemKey])
                }else {
                    item[itemKey] = ''
                }
            }

            return item

        },
        addInstance(obj, key, index){
            const instance = obj[key][0]
            let item = this.renderObject(instance)
            // obj[key].splice(index+1, 0, item)
            obj[key].push(item)
        },
        resetTargetKey(target, source){
            const _this = this
            for(let key in target){
                let obj = target[key]
                if(Object.prototype.toString.call(obj) == '[object Array]'){
                    _this.resetTargetKey(obj, obj.family.members)
                }else{
                    // 重置ip/port/portRange
                    _this.setCurrentPort(key, source, target)
                    // 如果找到当前端口对象，则重置
                    if(_this.currentItemFinded){
                       if(obj === ''){
                           return
                       }
                        // 1.该端口是否被占用端口，如果是从占用端口数组中删除
                        const vindex = _this.validatedFailed.findIndex(v => v.key == key && v.port == obj)
                        if(vindex != -1){
                            _this.validatedFailed.splice(vindex, 1)
                        }else{
                            // 2.端口不被占用, 查看该端口是否有效
                            const portType = _this.currentIPType.toLowerCase() == 'ip' ? 'inner' : 'outer'
                            let item = _this.currentPort
                            let arrs = _this[portType+'port'].filter(p => p.ip == _this.currentIP)
                            // let anotherArrs = _this[anotherType+'port'].filter(p => p.ip == _this.currentIP)
                            let array = _this.initArr(arrs, item)
                            // let anotherArray = _this.initArr(anotherArrs, item)
                            let val = array[Number(obj)]
                            // 3.无效端口不处理，有效端口重置
                            if(val != -1){
                                // 4.如果类型是port,重置port;
                                if(item.type.toLowerCase() == "port"){
                                    if(val == 2){
                                        array[Number(obj)] = item.protocol == 1 ? 4 : (item.protocol == 2 ? 3 : 1)
                                    }else{
                                        array[Number(obj)] = 1
                                    }
                                    _this.updateEle({
                                        ip: _this.currentIP,
                                        portArray: array,
                                        type: portType
                                    })
                                    // 如果有端口映射，删除验证过的映射
                                    if(item.mapping){
                                        _this.delVerifiedMap(target[item.mapping], item.protocol)
                                    }
                                }else{
                                    // 5.如果是portRange，重置范围
                                    let start = -1, end = -1
                                    let broRange = _this.currentRange.filter(r => r.key != item.key)[0]
                                    anotherPort = target[broRange.key] != '' ? Number(target[broRange.key]) : -1
                                    if(item.type.toLowerCase() == "startport"){
                                        start = Number(obj)
                                        end = anotherPort
                                    }else{
                                        end = Number(obj)
                                        start = anotherPort
                                    }
                                    // 如果范围无效，不处理
                                    if(start == -1 || end == -1){
                                        return
                                    }

                                    let rkey = _this.currentRange[0].key + _this.currentRange[1].key

                                    if(_this.rangeVerified.indexOf(rkey + start + end) != -1){
                                        _this.updateRangeVerified({
                                            type: 'del',
                                            data: rkey + start + end
                                        })
                                        _this.resetValidRange(start, end, array, item.protocol, portType)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        delInstance(obj, key, index, source){
            // 重置占用的端口
            let target = obj[key][index]
            this.resetTargetKey(target, source)

            obj[key].splice(index, 1)
        },
    setTips(item){
      if(!item.limits){
        return
      }

      let tips = []
      if(item.limits.ports && item.limits.ports.length > 0){
        tips = tips.concat(item.limits.ports)
      }

      if(item.limits.portRange && item.limits.portRange.length > 0){
        item.limits.portRange.forEach(r => {
          tips.push(`${r.start}~${r.end}`)
        })
      }

      const str = tips.length > 0 ? tips.join(',') : ''
      item.tips = str
    //   this.$set(item, 'tips', str)
    },
    setPortStatus(bro,type,wanIp,_opobj){
      let _this = this;
      let _portNum = Number(_this.formData[bro.key]);
      if(_opobj.portArray[Number(_portNum)] != -1){
        if(_opobj.portArray[Number(_portNum)] != 2){
          _opobj.portArray[Number(_portNum)] = 1
        }else{
          _opobj.portArray[Number(_portNum)] = bro.protocol == 1 ? 4 : (bro.protocol == 2 ? 3: 1)
        }

        _this.updateEle({
          ip: wanIp,
          portArray: _opobj.portArray,
          type: type
        })
      }
    },
      setPortStatusFirst(bro,wanIp,portType){
        let _this = this;
        let rindex = _this.validatedFailed.findIndex(v => v.key == bro.key && v.port == _this.formData[bro.key])
        if(rindex != -1){
            _this.validatedFailed.splice(rindex, 1)
          }else {
            let _opobj
            for(let i=0; i<_this[portType+'port'].length; i++){
              if(_this[portType+'port'][i].ip == wanIp){
                _opobj = _this[portType+'port'][i]
                break
              }
            }
            //改变IP之后需要修改之前port被设置的状态值
            if(_opobj){
              _this.setPortStatus(bro,portType,wanIp,_opobj)
            }
          }
      },
    // 选择ip后：1.查询对应的端口范围；2.清空之前选择的端口号
    selectIP(selectObj, end, ifClear){
      const _this = this
      const key = selectObj.type.toLowerCase()
      //let innerObj = null
      let item = null

      const ip = this.formData[selectObj.key]
      if(key == 'ip'){
        //innerObj = this.sourceVals[key]
        //处理映射的数据
        if(this.formData[selectObj.mapping] !=""){
          let wanIp = this.formData[selectObj.mapping];
          this.formData[selectObj.mapping] = "";
          if(wanIp){
          for(let i=0; i<_this.source.length; i++){
            if(_this.source[i].key == selectObj.mapping){

              if(_this.source[i].brother && _this.source[i].brother.ports){
                for(let bro of _this.source[i].brother.ports){
                  if(_this.formData[bro.key]){
                    if(_this.oldIP == wanIp){
                      _this.setPortStatusFirst(bro,wanIp,'inner')
                    }else {
                      _this.setPortStatusFirst(bro,wanIp,'outer')
                    }

                  }

                  let pvIndex = _this.portmapVerified.findIndex(pv => {
                    return (pv.ip.indexOf(wanIp)!=-1 && pv.port.indexOf(Number(_this.formData[bro.key])!=-1 && pv.protocol == bro.protocol))
                  })
                  if(pvIndex != -1){
                    _this.updatePortmapVerified({
                      type: 'del',
                      index: pvIndex
                    })
                  }
                  //清空被切换IP对应port的范围以及port的值
                  bro.tips = ""
                  this.formData[bro.key] = ""
                }
              }
              if(_this.source[i].brother && _this.source[i].brother.ranges){
                for(let bro of _this.source[i].brother.ranges){
                  for(let range of bro.range){
                    if(_this.oldIP == wanIp){
                      _this.setPortStatusFirst(range,wanIp,'inner')
                    }else {
                      _this.setPortStatusFirst(range,wanIp,'outer')
                    }
                  }
                }
              }
            }
          }
          }
        }
        for(let i=0; i<_this.sourceVals.length; i++){
          if(ip == _this.sourceVals[i].ip){
            item = _this.sourceVals[i];
            break;
          }
        }
      }else if(key == 'wanip'){
        if(this.formData[selectObj.mapping]){
          for(let i=0; i<_this.sourceVals.length; i++){
            if(this.formData[selectObj.mapping] == _this.sourceVals[i].ip){
              if(_this.sourceVals[i].ipMappingList){
                for(let j=0; j<_this.sourceVals[i].ipMappingList.length; j++){
                  if(ip == _this.sourceVals[i].ipMappingList[j].ip){
                    item = _this.sourceVals[i].ipMappingList[j];
                    _this.source.forEach( e =>{
                      if(e.key == selectObj.mapping && e.brother && e.brother.ports){
                        e.brother.ports.forEach( port => {
                          port.limits.portMap = item.portMap
                        })
                      }
                    })
                    break;
                  }
                }
              }else {
                item = _this.sourceVals[i]
              }

              break;
            }
          }
        }
      }

      const portType = selectObj.type.toLowerCase() == 'ip' ? 'inner' : 'outer'

      //清空对应端口
      if(selectObj.brother && selectObj.brother.ports && !ifClear){

        for(let bro of selectObj.brother.ports){
          if(_this.formData[bro.key]){

            _this.setPortStatusFirst(bro,_this.oldIP,portType)

            let pvIndex = _this.portmapVerified.findIndex(pv => {
              return (pv.ip.indexOf(_this.oldIP)!=-1 && pv.port.indexOf(Number(_this.formData[bro.key])!=-1 && pv.protocol == bro.protocol))
            })
            if(pvIndex != -1){
              _this.updatePortmapVerified({
                type: 'del',
                index: pvIndex
              })
            }

            _this.formData[bro.key] = ''
          }
        }
      }

      if(selectObj.brother && selectObj.brother.ranges){
        for(let bro of selectObj.brother.ranges){
          for(let range of bro.range){
            if(_this.formData[range.key]){

              _this.setPortStatusFirst(range,_this.oldIP,portType)

              let pvIndex = _this.portmapVerified.findIndex(pv => {
                return (pv.ip.indexOf(_this.oldIP)!=-1 && pv.port.indexOf(Number(_this.formData[bro.key])!=-1 && pv.protocol == bro.protocol))
              })
              if(pvIndex != -1){
                _this.updatePortmapVerified({
                  type: 'del',
                  index: pvIndex
                })
              }

              _this.formData[bro.key] = ''
            }
          }
        }
      }
      if(selectObj.brother && selectObj.brother.ranges && !ifClear){
        for(let bro of selectObj.brother.ranges){
          for(let range of bro.range){
            if(_this.formData[range.key]){
              _this.formData[range.key] = ''
            }
          }
        }
      }

      // 端口范围
      const limits = {
        ports: item ? item.ports : [],
        portRange: item ? item.portRange : [],
        portMap: item ? item.portMap: [],
        portAssets: item ? item.portAssets: []
      }
      if(selectObj.brother && selectObj.brother.ports){
        for(let bro of selectObj.brother.ports){
          bro.limits = limits
          bro.brotherIP = ip
          _this.setTips(bro)
        }
      }
      if(selectObj.brother && selectObj.brother.ranges){
        for(let range of selectObj.brother.ranges){

          for(let r of range.range){

            r.brotherIP = ip
            r.limits = {
              portRange: limits.portRange
            }
            // _this.$set(r, 'limits', {
            //   portRange: limits.portRange
            // })
            _this.setTips(r)
          }
        }
      }
      if(key == 'wanip' && !ifClear){
        _this.autoMapSelectIp(selectObj)
      }

      _this.$forceUpdate();
    },
    // 必填项规则
    renderRules(source){
      let _this = this
      source.forEach(item => {
        if(item.required){
          _this.rules[item.key] = [{ required: true, message: '必填项'}]
        }
        const validObj = _this.rules.port
        if(item.brother && item.brother.ports){
          item.brother.ports.forEach(bro => {
              if(bro.required){
                _this.rules[bro.key] = [validObj, { required: true, message: '必填项'}]
              }else{
                _this.rules[bro.key] = [validObj]
              }
          })
        }

        if(item.brother && item.brother.ranges){
          item.brother.ranges.forEach(bro => {
              item.brother.ranges.forEach(brange => {
                    if(brange.required){
                        _this.rules[brange.key] = [validObj, { required: true, message: '必填项'}]
                    }else{
                        _this.rules[brange.key] = [validObj]
                    }
              })

          })
        }

      })
    },
        // 资源回显,端口范围显示
        displayResource(){
            const _this = this
            if(Object.keys(_this.sourceVals).length == 0 || Object.keys(this.source).length == 0){
                return
            }

            this.source.forEach( selectObj => {
                const type = selectObj.type.toLowerCase()
                if(type == 'ip'){

                  let innerObj = _this.sourceVals
                  let ip = _this.formData[selectObj.key]
                  let wanip = _this.formData[selectObj.mapping]
                    let item = innerObj.filter(obj => obj.ip == ip)[0]
                    if(!item){
                        return
                    }
                  if(wanip){
                    if(item.ipMappingList){
                      for(let j=0; j<item.ipMappingList.length; j++){
                        if(wanip == item.ipMappingList[j].ip){
                          item.portMap = item.ipMappingList[j].portMap;
                          break;
                        }
                      }

                    }
                  }
                  const limits = {
                    ports: item ? item.ports : [],
                    portRange: item ? item.portRange : [],
                    portMap: item ? item.portMap: [],
                    portAssets: item ? item.portAssets: []
                  }
                    if(selectObj.brother && selectObj.brother.ports){
                        for(let bro of selectObj.brother.ports){
                            bro.limits = limits
                            bro.brotherIP = ip
                            _this.setTips(bro)
                        }
                    }
                    if(selectObj.brother && selectObj.brother.ranges){
                        for(let range of selectObj.brother.ranges){

                            for(let r of range.range){

                                r.brotherIP = ip
                                r.limits = {
                                    portRange: limits.portRange
                                }
                                _this.setTips(r)
                            }
                        }
                    }
                }else if(type == 'wanip'){
                  let innerObj = _this.sourceVals
                  let ip = _this.formData[selectObj.mapping]
                  let itemSource = innerObj.filter(obj => obj.ip == ip)[0]
                  if(!itemSource ){
                    return
                  }
                  let wanIp = _this.formData[selectObj.key]
                  let item = null
                  if(itemSource.ipMappingList){
                    for(let j=0; j<itemSource.ipMappingList.length; j++){
                      if(wanIp == itemSource.ipMappingList[j].ip){
                        item = itemSource.ipMappingList[j];
                        break;
                      }
                    }

                  }else {
                    item = itemSource
                  }
                  const limits = {
                    ports: item ? item.ports : [],
                    portRange: item ? item.portRange : [],
                    portMap: item ? item.portMap: [],
                    portAssets: item ? item.portAssets: []
                  }
                  if(selectObj.brother && selectObj.brother.ports){
                    for(let bro of selectObj.brother.ports){
                      bro.limits = limits
                      bro.brotherIP = ip
                      _this.setTips(bro)
                    }
                  }
                  if(selectObj.brother && selectObj.brother.ranges){
                    for(let range of selectObj.brother.ranges){

                      for(let r of range.range){

                        r.brotherIP = ip
                        r.limits = {
                          portRange: limits.portRange
                        }
                        _this.setTips(r)
                      }
                    }
                  }
                }
            })

            // this.updateEle({
            //     ip: _this.currentMapIP,
            //     portArray: anotherArray,
            //     type: anotherType
            // })
            if(this.ableEdit){
                this.$refs[this.refName].validate(valid => {
                    if(valid){
                        console.log(1)
                    }else{
                        console.log(2)
                    }
                })
            }

        },

    }
}
</script>
<style scoped>
.tips{
  font-size: 12px;color: #b3b1b1;
  margin-left: 4px;
  display: inline-block;
}
.collapse-title {
    flex: 1 1 auto;
    order: 1;
}
.titleIcon {
  cursor: pointer;
  margin-left: 10px;
  /* order: 2; */
}

/* .property >>> .el-form-item__label{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
} */

.property >>> .el-form-item__label{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.property >>> .el-collapse-item__header{
    border-top: 1px solid #EBEEF5;
}
.property >>> .el-collapse{
    border: none;
}
</style>
